import { useState, useEffect, useCallback } from "react";
import Web3 from "web3";
import "./App.css";
import Home from "./components/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NetworkSwitch from "./NetworkSwitch";

const web3 = new Web3(
  Web3.givenProvider ? Web3.givenProvider : "https://bsc-dataseed.binance.org/"
);

function App() {
  const [open, setOpen] = useState(false);

  let chain = useCallback(async () => {
    try {
      if (window.web3) {
        const chainid = await web3.eth.getChainId();
        if (+chainid !== 56) {
          setOpen(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    chain();
  }, [chain]);

  return (
    <div className="App">
      <BrowserRouter>
        <NetworkSwitch open={open} setOpen={setOpen} />

        {!open && (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route index element={<Home />} />
          </Routes>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
